import { AssetModuleTable } from '@/asset/AssetModuleTable';
import styles from './index.module.less';
import { Button } from 'antd';
import { cloneDeep } from 'lodash';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import ToolBarRender from '@/components/SPTableList/components/ToolBarRender';
import { ModuleInfo } from '@/common/model-apis/type';
import { PlusOutlined } from '@ant-design/icons';

export interface SpRecordListProps {
  value: any[];
  filterProps: any;
  activeKey: any;
  activeData: any;
  metaConfig: ModuleInfo;
  mainRecordValue: any;
  _headIdField?: string;
  headIdData?: string;
  onChange: (val: any) => void;
  refList?: any;
}

const SPFilterTable: React.FC<SpRecordListProps> = function SPFilterTable(props) {
  const {
    value = [],
    filterProps,
    activeKey,
    activeData,
    metaConfig,
    mainRecordValue,
    _headIdField,
    headIdData,
    onChange,
    refList,
    ...otherProps
  } = props;

  const tableRef = useRef<any>();
  const addTableData = () => {
    const fieldName = filterProps?.filterField;
    const oldValues = cloneDeep(value);
    const newItem: any = {
      [fieldName]: activeKey,
    };
    if (filterProps?.mapFields && filterProps.mapFields.length > 0) {
      filterProps.mapFields.forEach((el: any) => {
        if (el.tableField && el.treeField) {
          newItem[el.tableField] = activeData[el.treeField];
        }
      });
    }
    if (_headIdField) {
      newItem[_headIdField] = headIdData;
    }
    oldValues.push(newItem);
    onChange && onChange(oldValues);
  };

  const getDownloadOption = () => {
    const url = filterProps.downloadField;
    if (url) {
      const downloadOption = {
        title: '操作',
        valueType: 'option',
        dataIndex: 'options',
        fixed: 'right',
        width: 140,
        align: 'center',
        render: (_text: any, record: any, index: number) => {
          return (
            <span>
              <Button
                type="link"
                onClick={() => {
                  window.open(record[url]);
                }}
              >
                下载
              </Button>
            </span>
          );
        },
      };
      return downloadOption;
    }
    return false;
  };

  const validateFields = () => {
    return new Promise(async (resolve, reject) => {
      try {
        await tableRef.current?.validateFields();
      } catch (err) {
        console.log('err', err)
        reject(err);
      }
      const isRequiredCol = otherProps.columns?.filter((el: any) => el.isRequired)?.map((el: any) => el.dataIndex);
      let flag = true;
      value?.forEach((val: any) => {
        isRequiredCol.forEach((col: string) => {
          if (!val[col]) {
            flag = false;
          }
        });
      });
      if (flag) {
        resolve({
          module: otherProps.moduleID,
          validateFields: flag,
        });
      } else {
        reject({
          module: otherProps.moduleID,
          validateFields: flag,
        });
      }
    });
  };

  useEffect(() => {
    refList?.current.delete(`${otherProps.moduleID},${headIdData}`);
    refList?.current.set(`${otherProps.moduleID},${headIdData}`, {
      validateFields,
    });
  }, [value]);

  return (
    <>
      <AssetModuleTable
        {...otherProps}
        key={activeKey || 'all'}
        onChange={(val: any) => {
          if (activeKey) {
            const oldValue = cloneDeep(value);
            let ind = -1;
            const newValue = oldValue.map((el: any) => {
              if (el[filterProps?.filterField] === activeKey) {
                ind++;
                return val[ind] || el;
              }
              return el;
            });
            onChange && onChange(newValue);
          }
        }}
        value={value.filter((el: any) => activeKey && el[filterProps?.filterField] === activeKey)}
        ref={tableRef}
        rowDelable={false}
        optionColumns={metaConfig?.pageType !== 'view' ? {
          title: '操作',
          valueType: 'option',
          dataIndex: 'options',
          fixed: 'right',
          width: 140,
          align: 'center',
          render: (_text: any, record: any, index: number, rowIndex: number) => {
            return (
              <span>
                <Button
                  type="link"
                  disabled={record?.is_default}
                  onClick={() => {
                    const oldValue = cloneDeep(value);
                    if (activeKey) {
                      let ind = -1;
                      const newValue = oldValue.map((el: any) => {
                        if (el[filterProps?.filterField] === activeKey) {
                          ind++;
                          if (ind === rowIndex) {
                            return {
                              ...el,
                              delete: true,
                            };
                          }
                        }
                        return el;
                      });
                      const filterData = newValue.filter((el: any) => !el.delete);
                      onChange && onChange(filterData);
                    }
                  }}
                >
                  删除
                </Button>
              </span>
            );
          },
        } : getDownloadOption()}
        toolBarRender={[
          <>
            {activeKey && metaConfig?.pageType !== 'view' && (
              <Button type="primary" ghost onClick={addTableData}>
                <PlusOutlined /> 新建
              </Button>
            )}
          </>,
        ]}
      />
    </>
  );
};

export default SPFilterTable;
